import { Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * Widget line Widget
 */
@Component({
  selector: 'widget-full-line',//for compatibility reasons selector stays the same as in ng1
  templateUrl: './full-line-widget.component.html',
  styleUrls: ['./full-line-widget.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FullLineWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
   * The widget background color class
   */
  public widgetBackgroundColorClass: string; //Task 15286: Change to Widget line - remove dropdown standard list entries So => no more dropdown

  /**
   * Constructor
   * @param injector
   */
  constructor(injector: Injector) {
    super(injector, 'fullLine', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    this.executeWidgetDataLoadedInWidgetClass = true;
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useReadOnlySaveChangesHandler();
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    //Task 2062: Widget Lines - color variations
    //previos one and only was "dark-gray"
    this.widgetBackgroundColorClass = this.widgetConfig.widgetSettings.widgetBackgroundColorClass || 'widget-full-line-title-color-dark-grey';

    //Task 15286: Change to Widget line - remove dropdown standard list entries
    //before we loaded dropdown items from ref_l2_fullline

    this.page?.widgetDataLoaded(this.widgetConfig?.widgetSettings.id);
  }
}
